module.exports = __webpack_public_path__ + "img/structure-organization.80e339d2.jpg";